// extracted by mini-css-extract-plugin
export var activeNav = "Categories-module--activeNav--7260f";
export var blogNav = "Categories-module--blogNav--e0416";
export var fadeIn = "Categories-module--fadeIn--62235";
export var fadeOut = "Categories-module--fadeOut--b5639";